import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { WorkbookLineageSubplaceRouter, WorkbookLineageSubplaceRouterProps } from './WorkbookLineageSubplace';

export type EmbeddableWorkbookSubplaceProps = VizPortalDataCatalogProviderProps & WorkbookLineageSubplaceRouterProps;

export function EmbeddableWorkbookSubplaceWithoutRouter(props: EmbeddableWorkbookSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <WorkbookLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
